import $ from 'jquery';

$(function () {

	let slider = null;
	let slidesByName = {};
	let slidesByIndex = [];

	function initSlider() {

		$(".map-slider > div").each((index, elem) => {
			slidesByName[$(elem).data("slide-name")] = index;
			slidesByIndex.push($(elem).data("slide-name"));
		});

		if(slider === null && $('.map-slider').length > 0) {
			slider = tns({
				container: '.map-slider',
				items: 1,
				mouseDrag: true,
				// slideBy: 'page',
				gutter: "20",
				controls: true,
				navPosition: 'bottom',
				// autoplay: true,
				controlsContainer: ".slider-map-controls",
				// navContainer: ".tns-nav",
				// autoplayButtonOutput: true
			});

			slider.events.on("transitionEnd", () => {
				$('.map-activator .location-area').removeClass("active");
				$(".location-area", $(`.map-activator[data-label-name="${slidesByIndex[slider.getInfo().displayIndex - 1]}"]`)).addClass("active");
			});
		}
	}

	function destroySlider() {
		if(slider !== null)  {
			slider.destroy();
			slider = null;
		}
	}

	function main() {
		initSlider();
	}

	main();

	/* $(window).on('resize', (evt) => {
		if (window.innerWidth < 992) {
			destroySlider();
		}
		else main();
	});*/

	$(".location-area", $(".map-activator")[0]).addClass("active");
	$('.map-activator').on('mouseover', (evt) => {
		let i = slidesByName[$(evt.currentTarget).data("label-name")];
		$('.map-activator .location-area').removeClass("active");
		$(".location-area", evt.currentTarget).addClass("active");
		slider.goTo(i);
	});

});
